/* eslint-disable array-bracket-newline */
import React from 'react';
import { headTableColumnType } from '../ModalTable/HeadTable';

const useStatsTableData = () => {
  // table memoized required fields
  const columns: headTableColumnType[] = React.useMemo(
    () => [
      {
        text: 'Total USD',
        id: 'total',
        type: 'none',
      },
    ],
    []
  );

  return columns;
};

export { useStatsTableData };
